import OutlinedBoxContainer from "./styles";
export default OutlinedBoxContainer;
